import axios from 'axios';
import { CLASSIFIER_URL, POS_SERVER_TOKEN } from '../../config';

const instancePos = axios.create({
  baseURL: CLASSIFIER_URL, 
});

instancePos.interceptors.request.use(
  config => {
    const token = POS_SERVER_TOKEN
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


instancePos.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // window.location.href = '/login';  
    }
    return Promise.reject(error);
  }
);

export default instancePos;
